import { createFileRoute } from "@tanstack/react-router";
import { inviteStatusQueryOptions } from "@/features/auth/api/invite.queries";
import { JoinPage } from "@/features/auth/JoinPage";

export const Route = createFileRoute("/join/$token")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(inviteStatusQueryOptions(params.token)),
  component: JoinPage,
});
